import { useNavigate } from "react-router-dom";
import YildizArkaplan from "../components/YildizArkaplan";
import { REMIL_FIGURLER } from "../data/remilFigurler";

function FigurSembol({ pattern }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3, alignItems: "center" }}>
      {pattern.map((tip, i) => (
        <div key={i} style={{ display: "flex", gap: 3 }}>
          {tip === "tek" ? (
            <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#C9A84C" }} />
          ) : (
            <>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#C9A84C" }} />
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: "#C9A84C" }} />
            </>
          )}
        </div>
      ))}
    </div>
  );
}

export default function RemilNedir() {
  const navigate = useNavigate();
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0805 0%, #1a1205 40%, #0d0a05 100%)",
      position: "relative", fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420, margin: "0 auto",
    }}>
      <style>{`* { box-sizing: border-box; margin: 0; padding: 0; } ::-webkit-scrollbar { display: none; }`}</style>
      <YildizArkaplan />
      <div style={{ position: "relative", zIndex: 1, paddingBottom: 100 }}>

        <div style={{ padding: "24px 20px 16px", display: "flex", alignItems: "center", gap: 12 }}>
          <button onClick={() => navigate(-1)}
            style={{ background: "rgba(201,168,76,0.1)", border: "1px solid rgba(201,168,76,0.3)", borderRadius: 12, width: 38, height: 38, color: "#C9A84C", fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>‹</button>
          <div>
            <div style={{ fontSize: 20, fontWeight: 700, color: "#C9A84C" }}>Remil Nedir?</div>
            <div style={{ fontSize: 11, color: "rgba(201,168,76,0.5)", letterSpacing: 1.5 }}>KADİM KUM FALI</div>
          </div>
        </div>

        <div style={{ padding: "0 20px" }}>

          <div style={{ background: "rgba(201,168,76,0.05)", border: "1px solid rgba(201,168,76,0.15)", borderRadius: 16, padding: "20px", marginBottom: 20 }}>
            <div style={{ fontSize: 13, color: "rgba(255,255,255,0.75)", lineHeight: 1.8 }}>
              Remil, tarih boyunca kum üzerine çizilen şekiller üzerinden yorum yapılan kadim bir fal geleneğidir. Zaman içerisinde kum yerine kâğıt ve farklı yüzeyler kullanılmış olsa da "Remil" adı korunmuştur.
            </div>
          </div>

          <div style={{ fontSize: 13, color: "#C9A84C", fontWeight: 700, letterSpacing: 1, marginBottom: 12 }}>16 REMİL ŞEKLİ</div>
          <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginBottom: 16, lineHeight: 1.6 }}>
            Remil sistemi, 4 satırdan oluşan ve her satırın tek veya çift nokta içerdiği 16 temel şekle dayanır. Her şekil farklı enerji ve temaları temsil eder.
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 24 }}>
            {REMIL_FIGURLER.map(f => (
              <div key={f.id} style={{ background: "rgba(201,168,76,0.05)", border: "1px solid rgba(201,168,76,0.12)", borderRadius: 12, padding: "14px 10px", display: "flex", alignItems: "center", gap: 12 }}>
                <FigurSembol pattern={f.pattern} />
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#C9A84C" }}>{f.isim}</div>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.4)" }}>{f.gelenekselAd}</div>
                  <div style={{ fontSize: 10, color: "rgba(255,255,255,0.5)", marginTop: 3 }}>{f.anaTemalar.slice(0,2).join(" · ")}</div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ fontSize: 13, color: "#C9A84C", fontWeight: 700, letterSpacing: 1, marginBottom: 12 }}>REMİL GERÇEKTEN GELECEĞİ BİLİR Mİ?</div>
          <div style={{ background: "rgba(201,168,76,0.05)", border: "1px solid rgba(201,168,76,0.15)", borderRadius: 14, padding: "16px", marginBottom: 24, fontSize: 13, color: "rgba(255,255,255,0.65)", lineHeight: 1.8 }}>
            Remil bilimsel bir gelecek tahmin yöntemi değildir. Remil.app üzerindeki yorumlar eğlence ve kişisel farkındalık amacıyla sunulur. Semboller, düşüncelerinizi yansıtmak ve farklı bir perspektif kazanmak için bir araç olarak kullanılabilir.
          </div>

          <button onClick={() => navigate("/remil")}
            style={{ width: "100%", padding: "15px", borderRadius: 14, background: "linear-gradient(135deg, #5a3a00, #C9A84C)", border: "none", color: "#000", fontSize: 15, fontWeight: 800, cursor: "pointer" }}>
            ✦ Remil Falına Başla
          </button>
        </div>
      </div>
    </div>
  );
}
